import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useSWR from "swr";
import { OneBtnModal } from "components/common/modal";
import { AccountInfoTable } from "components/parkConsulting/detail";
import { putParkConsultingComplete } from "service/api/apply";
import type { IParkConsultingDetail } from "service/interface/apply";
import responseCodeConstant from "service/constant/responseCodeConstant";

export function ParkConsultingDetailPage() {
  const params = useParams();
  const [detailData, setDetailData] = useState<IParkConsultingDetail>(
    {} as IParkConsultingDetail,
  );
  const [isSuccessModalVisible, setISuccessModalVisible] =
    useState<boolean>(false);
  const { data } = useSWR(`/admin/manage/parkconsulting/${params.id}`);

  useEffect(() => {
    if (data) {
      setDetailData({
        ...data.data,
        memo: data.data.Memos[0]?.content,
      });
    }
  }, [data]);

  const handleMemoInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setDetailData((prev) => ({
      ...prev,
      memo: e.target.value,
    }));
  };

  const handleSaveBtn = async () => {
    const saveRes = await putParkConsultingComplete({
      parkConsultingId: params.id,
      body: {
        status: detailData.status,
        memo: detailData.memo,
      },
    });
    if (saveRes.status === responseCodeConstant.SUCCESS.ok) {
      setISuccessModalVisible(true);
    }
  };

  return (
    <>
      <OneBtnModal
        isVisible={isSuccessModalVisible}
        setIsVisible={setISuccessModalVisible}
        title="저장 완료"
        subTitle="저장이 완료 되었습니다."
        btnLabel="확인"
        btnClick={() => {}}
      />
      <div className="h-full min-h-[100vh] w-[calc(100%-273px)] bg-[#fdfdfd]">
        <div className="mx-auto w-[1167px] p-[78px_80px_72px_64px]">
          <p className="m-0 mb-[8px] text-[16px] font-semibold leading-[20px] text-gray-4 opacity-[0.5]">
            메모리올 관리자 화면
          </p>
          <div className="flex items-center justify-between">
            <p className="m-0 text-[32px] font-medium leading-[40px] text-black">
              추모공원 신청 정보
            </p>
          </div>
          <div className="mt-[32px] flex flex-col gap-[56px] rounded-[12px] bg-white p-[48px_40px_64px_48px] shadow-[0px_0px_8px_rgba(0,0,0,0.1)]">
            <AccountInfoTable data={detailData} setData={setDetailData} />
            <div>
              <p className="m-0 mb-[24px] text-[24px] font-semibold leading-[30px] text-black">
                메모
              </p>
              <textarea
                value={detailData.memo}
                onChange={handleMemoInput}
                className="h-[201px] w-full resize-none rounded-[8px] border-[2px] border-[#e2e2e2] bg-white px-[24px] py-[16px] text-M3 text-gray-5 outline-none focus:border-gray-5 focus:ring-0 focus:ring-white"
              />
              <div className="flex justify-end">
                <button
                  onClick={handleSaveBtn}
                  className="m-0 mt-[24px] h-[73px] w-[234px] rounded-[16px] bg-[#585858] text-[18px] font-semibold text-white"
                >
                  저장하기
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
